import { render } from "./HelpCatalogConfig.vue?vue&type=template&id=4bfc3b8e&scoped=true"
import script from "./HelpCatalogConfig.vue?vue&type=script&lang=js"
export * from "./HelpCatalogConfig.vue?vue&type=script&lang=js"

import "./HelpCatalogConfig.vue?vue&type=style&index=0&id=4bfc3b8e&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bfc3b8e"]])

export default __exports__